import { useState } from 'react';
import { Flex, SimpleGrid, Heading, Stack, Text, useDisclosure } from '@chakra-ui/react';
import CarouselDescription from './CarouselDescription';
import ModalScroll from './utils/ModalScroll/ModalScroll';


function FotografiaGaleria({ text, currentLang, imgList }) {

    var md = require('markdown-it')({ breaks: true });
    const subtitulo = md.render(text.sub);
    const labeledImgList = Object.values(imgList);
    
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [modalContent, setModalContent] = useState(labeledImgList[1]);

    function enlargeProject(id){
      let project = labeledImgList[id]
      setModalContent(project[currentLang]);
      onOpen();
    }

    return (
      <Flex direction='column'>
        <Stack direction='column' px={['5%','5%','15%','15%']} pt={['30%','30%','20%','5%']} pb={['70vh','70vh','130vh','15%']} textAlign={['center','center','center','left']} >
          <Heading>{ text.tit }</Heading>
          <Text dangerouslySetInnerHTML={{ __html: subtitulo }} fontSize='md' pt={['10%','10%','10%','0%']}></Text>
          
          <SimpleGrid columns={[1,1,1,2]} spacing={['7%','8%','7%','7%']} pt={['20%','7%']} pb={['70%', '20%']}>
            { labeledImgList.map( (data, i) => {
                return(
                  <Stack pl={['7%','0%']} position='relative' alignItems='center' justifyContent='center' key={i}>
                    <CarouselDescription data={data[currentLang]} size={500} dots={true} banner={true} nroProyecto={i} enlarge={enlargeProject} />
                    
                  </Stack>
                );
              }) 
            }
          </SimpleGrid>
        </Stack>
        <ModalScroll status={isOpen} close={onClose} justifyContent='center' alignItems='center'> 
          <CarouselDescription data={modalContent} size={1100} banner={false} enlargeIcon={false} />
        </ModalScroll>
      </Flex>
    );
}

export default FotografiaGaleria;
